<template>
  <b-dropdown
    right
    variant="info"
    class="ml-1"
    boundary="viewport"
  >
  <template v-slot:button-content>
    <i class="fa fa-indent mr-2"></i>
    <span>Options</span>
  </template>
    <router-link
      v-if="has('pm.orders.view')"
      :to="{
        name: 'Orders.Index',
        query: { projectId: project.id }
      }"
      class="dropdown-item"
    >
      Orders
    </router-link>

    <router-link
      v-if="has('pm.other.systemLogs')"
      :to="{
        name: 'ActionLog',
        query: { warehouseId: project.id }
      }"
      class="dropdown-item"
    >
      Action Log
    </router-link>
    <router-link
      v-if="has('pm.other.userLogs')"
      :to="{ name: 'UserLog', query: { warehouseId: project.id } }"
      class="dropdown-item"
    >
      User Log
    </router-link>

    <router-link
    v-if="has('pm.reports.storefrontProdStats')"
      :to="{
        name: 'Reports.StorefrontProductStatistics',
        params: { projectId: project.id }
      }"
      class="dropdown-item"
    >
      Storefront Inventory Stats
    </router-link>
    <router-link
    v-if="has('pm.reports.wmsProdStats')"
      :to="{
        name: 'Reports.WarehouseProductStatistics',
        params: { projId: project.id }
      }"
      class="dropdown-item"
    >
      Warehouse Inventory Stats
    </router-link>
    <router-link
      v-if="has('pm.warehouses.items.view')"
      :to="{
        name: 'Warehouses.Items',
        query: {
          brandId: project.brandId,
          warehouseId: project.warehouseId
        }
      }"
      class="dropdown-item"
    >
      Warehouse Items
    </router-link>
  </b-dropdown>
</template>

<script>
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  props: {
    project: {
      required: true
    }
  }
}
</script>

<style>

</style>
